import React, { useState, useEffect, useMemo } from 'react';
import { db, paths } from '../../firebase/config';
import { 
    collection, 
    query, 
    where, 
    getDocs, 
    doc, 
    setDoc, 
    getDoc, 
    onSnapshot, 
    updateDoc, 
    deleteField 
} from "firebase/firestore";
import { useAuth } from '../../context/AuthContext';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';

// --- ÍCONES (Mantidos Originais) ---
const CalendarIcon = ({ className }) => <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 00-2-2V7a2 2 0 00-2-2H5a2 2 0 00-2-2V12a2 2 0 002 2z" /></svg>;
const UserGroupIcon = ({ className }) => <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const ExclamationIcon = ({ className }) => <svg className={className || "w-5 h-5 text-red-500"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.398 16c-.77 1.333.192 3 1.732 3z" /></svg>;
const ClockIcon = ({ className }) => <svg className={className || "w-3 h-3 mr-1"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const ViewGridIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>;
const PrinterIcon = ({ className }) => <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>;
const TrashIcon = ({ className }) => <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>;
const ChevronLeftIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>;
const ChevronRightIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>;
const AlertIcon = () => <svg className="w-3 h-3 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.398 16c-.77 1.333.192 3 1.732 3z" /></svg>;
const CogIcon = () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826 3.31 2.37-2.37.996.608 2.296.096 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
const SaveIcon = ({ className }) => <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" /></svg>;
const PlusIcon = ({ className }) => <svg className={className || "w-5 h-5"} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>;

const DIAS_SEMANA = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta'];
const TEMPOS_AULA = ['1º Tempo', '2º Tempo', '3º Tempo', '4º Tempo', '5º Tempo', '6º Tempo'];

const DIAS_MAP = { 'Segunda': 0, 'Terça': 1, 'Quarta': 2, 'Quinta': 3, 'Sexta': 4 };
const TEMPOS_MAP = { '1º Tempo': 0, '2º Tempo': 1, '3º Tempo': 2, '4º Tempo': 3, '5º Tempo': 4, '6º Tempo': 5 };

const getWeekString = (date = new Date()) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const year = d.getUTCFullYear();
    const weekNo = Math.ceil((((d - new Date(Date.UTC(year, 0, 1))) / 86400000) + 1) / 7);
    return `${year}-W${String(weekNo).padStart(2, '0')}`;
};

const getMonthFromWeek = (weekString) => {
    const [yearStr, weekStr] = weekString.split('-W');
    const year = parseInt(yearStr, 10);
    const week = parseInt(weekStr, 10);
    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    return simple.getMonth();
};

const getDateRangeFromWeek = (weekString) => {
    if (!weekString) return "";
    const [yearStr, weekStr] = weekString.split('-W');
    const year = parseInt(yearStr, 10);
    const week = parseInt(weekStr, 10);
    
    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    const dow = simple.getDay();
    const ISOweekStart = simple;
    if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    
    const start = new Date(ISOweekStart);
    const end = new Date(start);
    end.setDate(end.getDate() + 6);
    
    const fmt = d => d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    return `${fmt(start)} a ${fmt(end)}`;
};

// --- Componentes Visuais (Mantidos) ---
const AulaCard = ({ entry, isEvento, isImpedido, onClick }) => {
    let borderClass = "border-l-4 border-blue-500";
    let bgClass = "bg-white hover:shadow-md";

    if (isEvento) {
        borderClass = "border-l-4 border-purple-500";
        bgClass = "bg-purple-50 hover:shadow-md";
    } else if (isImpedido) {
        borderClass = "border-l-4 border-amber-500";
        bgClass = "bg-amber-50 hover:bg-amber-100";
    }

    return (
        <div 
            onClick={onClick}
            className={`h-full w-full p-2 rounded-r-md shadow-sm transition-all cursor-pointer flex flex-col justify-center relative ${bgClass} ${borderClass}`}
        >
            <span className="font-bold text-[10px] leading-tight uppercase mb-1 block">
                {entry.materia_nome}
            </span>
            {!isEvento && (
                <div className="flex items-center text-[9px] text-gray-500">
                    <UserGroupIcon className="w-3 h-3 mr-1 opacity-50"/>
                    <span className="truncate">{entry.professor_nome || "Sem professor"}</span>
                </div>
            )}
            {isImpedido && !isEvento && (
                <div className="absolute top-1 right-1">
                    <div className="text-amber-600 bg-white rounded-full p-0.5 shadow-sm" title="Conflito de Horário">
                        <ExclamationIcon className="w-3 h-3" />
                    </div>
                </div>
            )}
        </div>
    );
};

const EmptySlot = ({ onClick }) => (
    <div 
        onClick={onClick}
        className="h-full w-full rounded-md border-2 border-dashed border-gray-200 flex items-center justify-center cursor-pointer hover:border-blue-300 hover:bg-blue-50 transition-colors group"
    >
        <PlusIcon className="w-5 h-5 text-gray-300 group-hover:text-blue-400" />
    </div>
);

export const CronogramaDashboard = () => {
    const { userProfile } = useAuth();
    const [loading, setLoading] = useState(true);
    
    // Dados Globais
    const [turmas, setTurmas] = useState([]);
    const [pelotoes, setPelotoes] = useState([]);
    const [materias, setMaterias] = useState([]);
    const [professores, setProfessores] = useState([]);
    const [impedimentos, setImpedimentos] = useState({});
    
    // Estados de Seleção e Navegação
    const [selectedWeek, setSelectedWeek] = useState(getWeekString());
    const [activeTurmaId, setActiveTurmaId] = useState('');
    const [activePelotaoId, setActivePelotaoId] = useState('geral'); 

    // Dados de Cronograma
    const [scheduleData, setScheduleData] = useState({});
    const [allWeeklySchedules, setAllWeeklySchedules] = useState([]);
    const [allSchedules, setAllSchedules] = useState([]);

    // Modal Edição
    const [showModal, setShowModal] = useState(false);
    const [editingSlot, setEditingSlot] = useState({ dia: '', tempo: '', pelotaoId: '' }); 
    const [formAula, setFormAula] = useState({ materia_id: '', professor_id: '' });
    const [conflictWarning, setConflictWarning] = useState('');
    const [modalTab, setModalTab] = useState('materia');
    const [isEditingExisting, setIsEditingExisting] = useState(false);
    const [originalProfessorId, setOriginalProfessorId] = useState('');

    // Modal Config PDF
    const [showConfigPdfModal, setShowConfigPdfModal] = useState(false);
    const [pdfConfig, setPdfConfig] = useState({
        observacoes: '',
        assinaturas: [
            { nome: '', funcao: 'Chefe da Seção de Coordenação' }, 
            { nome: '', funcao: 'Chefe do Departamento de Ensino' }, 
            { nome: '', funcao: 'Elaboração' }
        ]
    });

    useEffect(() => {
        setLoading(true);
        const unsubTurmas = onSnapshot(collection(db, paths.turmas), (s) => {
            const lista = s.docs.map(d => ({id: d.id, ...d.data()})).sort((a,b) => a.nome.localeCompare(b.nome));
            setTurmas(lista);
            if (lista.length > 0 && !activeTurmaId) setActiveTurmaId(lista[0].id);
        });
        const unsubPelotoes = onSnapshot(collection(db, paths.pelotoes), (s) => setPelotoes(s.docs.map(d => ({id: d.id, ...d.data()})).sort((a,b) => a.nome.localeCompare(b.nome))));
        const unsubMaterias = onSnapshot(collection(db, paths.materias), (s) => setMaterias(s.docs.map(d => ({id: d.id, ...d.data()}))));
        const unsubProfessores = onSnapshot(collection(db, paths.professores), (s) => setProfessores(s.docs.map(d => ({id: d.id, ...d.data()}))));
        
        const unsubAllSchedules = onSnapshot(collection(db, paths.cronogramas), (snap) => {
            setAllSchedules(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });

        // Carrega Configuração Salva do PDF
        const loadPdfConfig = async () => {
            try {
                const docRef = doc(db, 'configuracoes', 'pdf_qts');
                const snap = await getDoc(docRef);
                if (snap.exists()) {
                    setPdfConfig(snap.data());
                }
            } catch (e) {
                console.error("Erro ao carregar config PDF", e);
            }
        };
        loadPdfConfig();

        setLoading(false);
        return () => { unsubTurmas(); unsubPelotoes(); unsubMaterias(); unsubProfessores(); unsubAllSchedules(); };
    }, [activeTurmaId]);

    // Recarrega impedimentos ao mudar semana
    useEffect(() => {
        const loadImpedimentosDaSemana = async () => {
            if (!selectedWeek) return;
            const snap = await getDocs(collection(db, paths.impedimentos));
            const impData = {};
            snap.forEach(doc => {
                const weekData = doc.data()[selectedWeek]; 
                if (weekData && weekData.slots) {
                    impData[doc.id] = weekData.slots; 
                } else {
                    impData[doc.id] = {};
                }
            });
            setImpedimentos(impData);
        };
        loadImpedimentosDaSemana();
    }, [selectedWeek]);

    useEffect(() => {
        if (!selectedWeek) return;
        const schedulesThisWeek = allSchedules.filter(s => s.semana === selectedWeek);
        setAllWeeklySchedules(schedulesThisWeek);
        if (activePelotaoId !== 'geral') {
            const current = schedulesThisWeek.find(s => s.pelotao_id === activePelotaoId);
            setScheduleData(current ? current.grade || {} : {});
        }
    }, [selectedWeek, activePelotaoId, allSchedules]);

    const handleWeekChange = (offset) => {
        const [yearStr, weekStr] = selectedWeek.split('-W');
        let year = parseInt(yearStr, 10);
        let week = parseInt(weekStr, 10);
        week += offset;
        if (week > 52) { week = 1; year++; }
        else if (week < 1) { week = 52; year--; }
        setSelectedWeek(`${year}-W${String(week).padStart(2, '0')}`);
    };

    const getProfessorDisplayName = (profId, profNameFallback) => {
        if (!profId) return profNameFallback;
        const prof = professores.find(p => p.id === profId);
        return prof ? `${prof.posto ? prof.posto + ' ' : ''}${prof.nome_completo}` : profNameFallback;
    };

    const pelotoesDaTurma = useMemo(() => {
        return pelotoes.filter(p => p.turma_id === activeTurmaId);
    }, [pelotoes, activeTurmaId]);

    const getProgressoMateria = (materiaId, currentDia, currentTempo, pelotaoId) => {
        if (!materiaId || !pelotaoId) return { ministradas: 0, total: 0 };
        const materia = materias.find(m => m.id === materiaId);
        if (materia?.tipo === 'evento') return { ministradas: 0, total: 0, isEvento: true };
        const totalHoras = materia?.carga_horaria ? parseInt(String(materia.carga_horaria).replace(/\D/g, ''), 10) : 0;
        const currentWeight = (DIAS_MAP[currentDia] * 10) + TEMPOS_MAP[currentTempo];
        let aulasCount = 0;
        const cronogramasDoPelotao = allSchedules.filter(s => s.pelotao_id === pelotaoId);
        cronogramasDoPelotao.forEach(cronograma => {
            if (!cronograma.grade) return;
            const isPastWeek = cronograma.semana < selectedWeek;
            const isCurrentWeek = cronograma.semana === selectedWeek;
            Object.keys(cronograma.grade).forEach(key => {
                const entry = cronograma.grade[key];
                if (entry && entry.materia_id === materiaId) {
                    if (isPastWeek) aulasCount++;
                    else if (isCurrentWeek) {
                        const [d, t] = key.split('-');
                        const entryWeight = (DIAS_MAP[d] * 10) + TEMPOS_MAP[t];
                        if (entryWeight <= currentWeight) aulasCount++;
                    }
                }
            });
        });
        const ministradasAteAgora = aulasCount * 2;
        return { ministradas: ministradasAteAgora, total: totalHoras, isEvento: false };
    };

    const getInfoProfessor = (profId) => {
        if (!profId) return { mensal: 0, semanal: 0 };
        const currentMonth = getMonthFromWeek(selectedWeek);
        let aulasMensal = 0;
        let aulasSemanal = 0;
        allSchedules.forEach(schedule => {
            if (!schedule.grade) return;
            const monthOfSchedule = getMonthFromWeek(schedule.semana);
            const isSameMonth = monthOfSchedule === currentMonth;
            const isSameWeek = schedule.semana === selectedWeek;
            if (isSameMonth) {
                Object.values(schedule.grade).forEach(aula => {
                    if (aula.professor_id === profId) {
                        aulasMensal++;
                        if (isSameWeek) aulasSemanal++;
                    }
                });
            }
        });
        return { mensal: aulasMensal, semanal: aulasSemanal };
    };

    const handleCellClick = (dia, tempo, pelotaoId) => {
        const targetPelotao = pelotaoId || activePelotaoId;
        if (targetPelotao === 'geral') return; 
        const currentSchedule = allWeeklySchedules.find(s => s.pelotao_id === targetPelotao)?.grade || {};
        const currentEntry = currentSchedule[`${dia}-${tempo}`] || {};
        setEditingSlot({ dia, tempo, pelotaoId: targetPelotao });
        setFormAula({ materia_id: currentEntry.materia_id || '', professor_id: currentEntry.professor_id || '' });
        setIsEditingExisting(!!currentEntry.materia_id);
        setOriginalProfessorId(currentEntry.professor_id || '');
        if (currentEntry.tipo === 'evento') setModalTab('evento'); else setModalTab('materia');
        setConflictWarning('');
        setShowModal(true);
    };

    const checkConflicts = (profId, materiaId) => {
        let warnings = [];
        if (materiaId) {
            const { ministradas, total, isEvento } = getProgressoMateria(materiaId, editingSlot.dia, editingSlot.tempo, editingSlot.pelotaoId);
            if (!isEvento && total > 0 && ministradas > total) return `🚫 Carga horária da matéria esgotada (${ministradas}/${total}h).`;
        }
        if (!profId) return '';
        const slotKey = `${editingSlot.dia}-${editingSlot.tempo}`;
        if (impedimentos[profId] && impedimentos[profId][slotKey]) {
            if (profId === originalProfessorId) warnings.push(`⚠️ ATENÇÃO: O professor sinalizou IMPEDIMENTO neste horário.`);
            else return `🚫 PROIBIDO: O professor possui IMPEDIMENTO neste horário e não pode ser escalado.`;
        }
        for (const schedule of allWeeklySchedules) {
            if (schedule.pelotao_id === editingSlot.pelotaoId) continue;
            const entry = schedule.grade?.[slotKey];
            if (entry && entry.professor_id === profId) {
                const pelotaoNome = pelotoes.find(p => p.id === schedule.pelotao_id)?.nome || "Outro Pelotão";
                return `🚫 O professor já está alocado no ${pelotaoNome} neste horário.`;
            }
        }
        return warnings.join(' ');
    };

    useEffect(() => {
        setConflictWarning(checkConflicts(formAula.professor_id, formAula.materia_id));
    }, [formAula.professor_id, formAula.materia_id]);

    const handleSaveAula = async (e) => {
        e.preventDefault();
        if (conflictWarning.includes('🚫')) return alert("Não é possível salvar: " + conflictWarning);
        const { dia, tempo, pelotaoId } = editingSlot;
        const key = `${dia}-${tempo}`;
        const materiaObj = materias.find(m => m.id === formAula.materia_id);
        const profObj = professores.find(p => p.id === formAula.professor_id);
        const isEventoTab = modalTab === 'evento';
        const professorNomeCompleto = isEventoTab ? '' : (profObj ? `${profObj.posto ? profObj.posto + ' ' : ''}${profObj.nome_completo}` : 'Sem Professor');
        const newEntry = formAula.materia_id ? {
            materia_id: formAula.materia_id, materia_nome: materiaObj?.nome || '',
            professor_id: isEventoTab ? '' : formAula.professor_id, professor_nome: professorNomeCompleto,
            tipo: isEventoTab ? 'evento' : 'materia'
        } : null;
        const currentScheduleObj = allWeeklySchedules.find(s => s.pelotao_id === pelotaoId);
        const currentGrade = currentScheduleObj ? { ...currentScheduleObj.grade } : {};
        if (newEntry) currentGrade[key] = newEntry; else delete currentGrade[key];
        const docId = `${selectedWeek}_${pelotaoId}`;
        await setDoc(doc(db, paths.cronogramas, docId), { semana: selectedWeek, pelotao_id: pelotaoId, grade: currentGrade }, { merge: true });
        setShowModal(false);
    };

    const handleDeleteAula = async () => {
        if (!window.confirm("Tem certeza que deseja excluir esta aula?")) return;
        const { dia, tempo, pelotaoId } = editingSlot;
        const key = `${dia}-${tempo}`;
        const docId = `${selectedWeek}_${pelotaoId}`;
        try {
            const docRef = doc(db, paths.cronogramas, docId);
            await updateDoc(docRef, { [`grade.${key}`]: deleteField() });
            setShowModal(false);
        } catch (err) {
            console.error("Erro ao excluir aula (fallback):", err);
            try {
                let currentScheduleObj = allWeeklySchedules.find(s => s.pelotao_id === pelotaoId);
                let currentGrade = currentScheduleObj ? { ...currentScheduleObj.grade } : {};
                if (!currentScheduleObj && activePelotaoId === pelotaoId) currentGrade = { ...scheduleData };
                delete currentGrade[key];
                await setDoc(doc(db, paths.cronogramas, docId), { semana: selectedWeek, pelotao_id: pelotaoId, grade: currentGrade }, { merge: false });
                setShowModal(false);
            } catch (retryErr) { alert("Erro ao excluir aula: " + retryErr.message); }
        }
    };

    const handleAddSignature = () => { setPdfConfig(prev => ({ ...prev, assinaturas: [...prev.assinaturas, { nome: '', funcao: '' }] })); };
    const handleRemoveSignature = (index) => { setPdfConfig(prev => ({ ...prev, assinaturas: prev.assinaturas.filter((_, i) => i !== index) })); };
    const handleSignatureChange = (index, field, value) => { const newSignatures = [...pdfConfig.assinaturas]; newSignatures[index][field] = value; setPdfConfig({ ...pdfConfig, assinaturas: newSignatures }); };

    const handleSavePdfConfig = async () => {
        try {
            const docRef = doc(db, 'configuracoes', 'pdf_qts');
            await setDoc(docRef, pdfConfig);
            alert("Configuração de assinaturas e observações salva com sucesso!");
        } catch (error) {
            console.error("Erro ao salvar config:", error);
            alert("Erro ao salvar configuração: " + error.message);
        }
    };

    const handlePrintVisaoGeral = () => {
        const turmaNome = turmas.find(t => t.id === activeTurmaId)?.nome || 'Turma';
        const dateRange = getDateRangeFromWeek(selectedWeek);
        const printWindow = window.open('', '_blank');
        const dataGeracao = new Date().toLocaleString('pt-BR');
        
        let html = `
            <html>
            <head>
                <title>QTS Visão Geral - ${turmaNome}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 10px; font-size: 10px; }
                    .header-banner { border: 2px solid #000; padding: 10px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between; page-break-inside: avoid; }
                    .header-left img, .header-right img { height: 60px; width: auto; }
                    .header-center { text-align: center; flex: 1; font-weight: bold; text-transform: uppercase; line-height: 1.2; color: #000080; }
                    table { width: 100%; border-collapse: collapse; margin-bottom: 20px; page-break-inside: avoid; table-layout: fixed; }
                    th, td { border: 1px solid #ccc; padding: 4px; text-align: center; vertical-align: middle; word-wrap: break-word; }
                    th { background-color: #f0f0f0; font-weight: bold; }
                    .pelotao-header { background-color: #e0e7ff; font-weight: bold; color: #1e3a8a; text-align: left; padding: 5px; }
                    .materia { font-weight: bold; color: #000; font-size: 11px; }
                    .professor { font-size: 9px; color: #555; display: block; margin-top: 2px; }
                    .evento { color: #5b21b6; font-weight: bold; text-transform: uppercase; }
                    .vazio { color: #ccc; }
                    .footer-container { margin-top: 30px; page-break-inside: avoid; }
                    .obs-box { border: 1px solid #ccc; padding: 10px; margin-bottom: 20px; min-height: 50px; }
                    .obs-title { font-weight: bold; text-decoration: underline; margin-bottom: 5px; display: block; }
                    .signatures-container { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 50px; padding-left: 20px; padding-right: 20px; }
                    .signature-block { text-align: center; width: 30%; }
                    .signature-line { border-top: 1px solid #000; margin: 10px auto; width: 90%; }
                    .sig-name { font-weight: bold; font-size: 11px; text-transform: uppercase; }
                    .sig-func { font-size: 10px; }
                    @page { size: landscape; margin: 0.8cm; }
                </style>
            </head>
            <body>
                <div class="header-banner">
                    <div class="header-left"><img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão" /></div>
                    <div class="header-center">
                        <div>ACADEMIA DE POLÍCIA MILITAR DO BARRO BRANCO</div>
                        <div>DEPARTAMENTO DE ENSINO</div>
                        <div>SEÇÃO DE COORDENAÇÃO</div>
                        <div style="margin-top: 5px;">QUADRO DE TRABALHO SEMANAL (QTS)</div>
                        <div style="font-size: 14px; margin: 5px 0;">${turmaNome.toUpperCase()}</div>
                        <div style="font-size: 11px; color: #000;">PERÍODO: ${dateRange}</div>
                    </div>
                    <div class="header-right"><img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão" /></div>
                </div>
                <p style="text-align: center; font-size: 9px;">Gerado em: ${dataGeracao}</p>
        `;

        if (pelotoesDaTurma.length === 0) { html += '<p style="text-align: center;">Nenhum pelotão encontrado.</p>'; } 
        else {
            pelotoesDaTurma.forEach(pelotao => {
                const pSchedule = allWeeklySchedules.find(s => s.pelotao_id === pelotao.id)?.grade || {};
                html += `<div class="pelotao-header">${pelotao.nome}</div><table><thead><tr><th style="width: 60px;">Horário</th>${DIAS_SEMANA.map(d => `<th>${d}</th>`).join('')}</tr></thead><tbody>`;
                TEMPOS_AULA.forEach(tempo => {
                    html += `<tr><td>${tempo}</td>`;
                    DIAS_SEMANA.forEach(dia => {
                        const entry = pSchedule[`${dia}-${tempo}`];
                        const isEvento = entry?.tipo === 'evento';
                        if (entry) { 
                            const nomeProf = getProfessorDisplayName(entry.professor_id, entry.professor_nome);
                            html += `<td><span class="${isEvento ? 'evento' : 'materia'}">${entry.materia_nome}</span>${!isEvento ? `<span class="professor">${nomeProf}</span>` : ''}</td>`; 
                        } else { html += `<td><span class="vazio">-</span></td>`; }
                    });
                    html += `</tr>`;
                });
                html += `</tbody></table>`;
            });
        }

        html += `<div class="footer-container">`;
        if (pdfConfig.observacoes) { html += `<div class="obs-box"><span class="obs-title">Observações:</span>${pdfConfig.observacoes.replace(/\n/g, '<br>')}</div>`; }
        html += `<div class="signatures-container">`;
        const totalSigs = pdfConfig.assinaturas.length;
        pdfConfig.assinaturas.forEach((sig, index) => {
            const isMiddle = totalSigs === 3 && index === 1;
            const style = isMiddle ? 'margin-bottom: 60px;' : '';
            html += `<div class="signature-block" style="${style}"><div class="signature-line"></div><div class="sig-name">${sig.nome || '____________________'}</div><div class="sig-func">${sig.funcao}</div></div>`;
        });
        html += `</div></div><script>window.print();</script></body></html>`;
        printWindow.document.write(html);
        printWindow.document.close();
    };

    if (loading) return <LoadingSpinner />;

    return (
        <div className="min-h-screen bg-gray-50/50 p-6"> 
            
            {/* --- CABEÇALHO --- */}
            <header className="flex flex-col md:flex-row justify-between items-end mb-8 border-b border-gray-200 pb-4">
                <div>
                    <h1 className="text-2xl font-bold text-slate-800 flex items-center gap-2">
                        <CalendarIcon className="text-blue-600 w-6 h-6"/> 
                        Quadro de Trabalho Semanal
                    </h1>
                    <p className="text-sm text-slate-500 mt-1 ml-8">
                        Gerenciamento de grade horária e alocação de instrutores.
                    </p>
                </div>

                <div className="flex items-center bg-white rounded-xl shadow-sm border border-gray-200 p-1">
                    <button onClick={() => handleWeekChange(-1)} className="p-2 hover:bg-gray-100 rounded-lg text-slate-600 transition-colors">
                        <ChevronLeftIcon className="w-5 h-5"/>
                    </button>
                    
                    <div className="px-4 text-center border-l border-r border-gray-100 mx-1">
                        <span className="block text-xs text-gray-400 uppercase font-bold tracking-wider">Semana {selectedWeek.split('-W')[1]}</span>
                        <span className="block text-sm font-bold text-slate-700">{getDateRangeFromWeek(selectedWeek)}</span>
                    </div>

                    <button onClick={() => handleWeekChange(1)} className="p-2 hover:bg-gray-100 rounded-lg text-slate-600 transition-colors">
                        <ChevronRightIcon className="w-5 h-5"/>
                    </button>
                </div>
            </header>

            {/* --- ÁREA DE ABAS (Estilo GerenciadorDashboard) --- */}
            {/* 1. SELEÇÃO DE TURMAS (Abas Principais - Estilo Cápsula) */}
            <div className="mb-6">
                <div className="flex bg-gray-200 p-1 rounded-xl shadow-inner w-full md:w-auto overflow-x-auto scrollbar-hide">
                    {turmas.map(t => (
                        <button 
                            key={t.id} 
                            onClick={() => { setActiveTurmaId(t.id); setActivePelotaoId('geral'); }} 
                            className={`
                                px-5 py-2 rounded-lg text-sm font-bold transition-all capitalize whitespace-nowrap
                                ${activeTurmaId === t.id 
                                    ? 'bg-white text-gray-800 shadow-sm ring-1 ring-black/5' 
                                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-200/50'}
                            `}
                        >
                            {t.nome}
                        </button>
                    ))}
                </div>
            </div>

            {/* 2. SELEÇÃO DE PELOTÕES (Sub-filtros - Estilo Chips) */}
            <div className="flex flex-wrap items-center justify-between gap-4 mb-6 bg-white p-3 rounded-2xl shadow-sm border border-gray-100">
                <div className="flex gap-2 overflow-x-auto">
                    {/* Botão Visão Geral (Estilo Chip Destacado) */}
                    <button 
                        onClick={() => setActivePelotaoId('geral')} 
                        className={`
                            px-4 py-2 rounded-full text-xs font-bold border transition-all duration-200 whitespace-nowrap cursor-pointer select-none flex items-center gap-2
                            ${activePelotaoId === 'geral' 
                                ? 'bg-indigo-600 text-white border-indigo-600 shadow-md' 
                                : 'bg-white text-gray-500 border-gray-200 hover:bg-indigo-50 hover:text-indigo-600'}
                        `}
                    >
                        <ViewGridIcon /> Visão Geral
                    </button>
                    
                    <div className="w-px h-6 bg-gray-200 mx-2 self-center"></div> 

                    {/* Chips dos Pelotões */}
                    {pelotoesDaTurma.map(p => (
                        <button 
                            key={p.id} 
                            onClick={() => setActivePelotaoId(p.id)} 
                            className={`
                                px-4 py-2 rounded-full text-xs font-bold border transition-all duration-200 whitespace-nowrap cursor-pointer select-none
                                ${activePelotaoId === p.id 
                                    ? 'bg-blue-600 text-white border-blue-600 shadow-md transform scale-105' 
                                    : 'bg-white text-gray-500 border-gray-200 hover:bg-blue-50 hover:text-blue-600'}
                            `}
                        >
                            {p.nome}
                        </button>
                    ))}
                </div>

                {activePelotaoId === 'geral' && (
                    <div className="flex gap-2">
                        <Button onClick={() => setShowConfigPdfModal(true)} variant="outline" className="text-xs px-4 py-2 h-9 border-gray-300 text-gray-600 hover:bg-gray-50 flex items-center gap-2">
                            <CogIcon className="w-4 h-4"/> Config. PDF
                        </Button>
                        <Button onClick={handlePrintVisaoGeral} variant="outline" className="text-xs px-4 py-2 h-9 border-gray-300 text-gray-600 hover:bg-gray-50 flex items-center gap-2">
                            <PrinterIcon className="w-4 h-4"/> Imprimir PDF
                        </Button>
                    </div>
                )}
            </div>

            {/* --- ÁREA DE CONTEÚDO DA GRADE (Mantido Original) --- */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                {activePelotaoId === 'geral' ? (
                    <div className="divide-y divide-gray-100">
                        {pelotoesDaTurma.length === 0 ? (
                            <div className="p-12 text-center text-gray-400">Selecione uma turma com pelotões cadastrados.</div>
                        ) : (
                            pelotoesDaTurma.map(pelotao => {
                                const pSchedule = allWeeklySchedules.find(s => s.pelotao_id === pelotao.id)?.grade || {};
                                return (
                                    <div key={pelotao.id} className="p-4 hover:bg-slate-50 transition-colors">
                                        <div className="flex items-center mb-3">
                                            <div className="w-2 h-6 bg-blue-600 rounded-full mr-2"></div>
                                            <h3 className="font-bold text-slate-700 uppercase tracking-wide text-sm">{pelotao.nome}</h3>
                                            <button onClick={() => setActivePelotaoId(pelotao.id)} className="ml-auto text-xs text-blue-600 font-medium hover:underline">
                                                Editar Individualmente →
                                            </button>
                                        </div>
                                        
                                        <div className="grid grid-cols-7 gap-2">
                                            <div className="col-span-1 space-y-2 pt-8">
                                                {TEMPOS_AULA.map(t => (
                                                    <div key={t} className="h-16 flex items-center justify-end pr-3 text-[10px] font-bold text-gray-400 uppercase tracking-tighter">
                                                        {t}
                                                    </div>
                                                ))}
                                            </div>

                                            {DIAS_SEMANA.map(dia => (
                                                <div key={dia} className="col-span-1 flex flex-col gap-2">
                                                    <div className="text-center text-[10px] font-bold text-slate-500 uppercase py-2 bg-gray-100 rounded-md">
                                                        {dia.substring(0, 3)}
                                                    </div>
                                                    {TEMPOS_AULA.map(tempo => {
                                                        const entry = pSchedule[`${dia}-${tempo}`];
                                                        const isEvento = entry?.tipo === 'evento';
                                                        const isImpedido = impedimentos[entry?.professor_id] && impedimentos[entry?.professor_id][`${dia}-${tempo}`];
                                                        
                                                        return (
                                                            <div key={tempo} className="h-16">
                                                                {entry ? (
                                                                    <AulaCard 
                                                                        entry={entry} 
                                                                        isEvento={isEvento} 
                                                                        isImpedido={isImpedido} 
                                                                        onClick={() => handleCellClick(dia, tempo, pelotao.id)}
                                                                    />
                                                                ) : (
                                                                    <EmptySlot onClick={() => handleCellClick(dia, tempo, pelotao.id)} />
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                ) : (
                    <div className="p-6">
                        <table className="w-full table-fixed border-separate border-spacing-2">
                            <thead>
                                <tr>
                                    <th className="w-20"></th>
                                    {DIAS_SEMANA.map(dia => (
                                        <th key={dia} className="pb-4 text-center">
                                            <div className="bg-slate-800 text-white py-2 rounded-lg text-xs font-bold uppercase shadow-md tracking-wider">
                                                {dia}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {TEMPOS_AULA.map((tempo, index) => (
                                    <tr key={tempo}>
                                        <td className="align-middle">
                                            <div className="flex flex-col items-center justify-center h-20 bg-gray-100 rounded-lg text-gray-500 text-[10px] font-bold border border-gray-200">
                                                <span>{index + 1}º</span>
                                                <span>TEMPO</span>
                                            </div>
                                        </td>

                                        {DIAS_SEMANA.map(dia => {
                                            const entry = scheduleData[`${dia}-${tempo}`];
                                            const isEvento = entry?.tipo === 'evento';
                                            const isImpedido = impedimentos[entry?.professor_id] && impedimentos[entry?.professor_id][`${dia}-${tempo}`];
                                            
                                            return (
                                                <td key={dia} className="h-24 align-top">
                                                    {entry ? (
                                                        <AulaCard 
                                                            entry={entry}
                                                            isEvento={isEvento}
                                                            isImpedido={isImpedido}
                                                            onClick={() => handleCellClick(dia, tempo, activePelotaoId)}
                                                        />
                                                    ) : (
                                                        <div 
                                                            onClick={() => handleCellClick(dia, tempo, activePelotaoId)}
                                                            className="h-full w-full rounded-lg border border-dashed border-gray-200 bg-gray-50/50 hover:bg-blue-50 hover:border-blue-300 transition-all cursor-pointer flex items-center justify-center"
                                                        >
                                                            <PlusIcon className="text-gray-300 w-6 h-6" />
                                                        </div>
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* --- MODAIS (Mantidos Originais) --- */}
            <Modal show={showModal} onClose={() => setShowModal(false)} title={`Editar Aula - ${editingSlot.dia} (${editingSlot.tempo})`}>
                 <form onSubmit={handleSaveAula} className="space-y-4">
                    <div className="flex space-x-2 border-b mb-4">
                        <button type="button" onClick={() => setModalTab('materia')} className={`px-4 py-2 font-bold text-sm border-b-2 transition-colors ${modalTab === 'materia' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>Matéria</button>
                        <button type="button" onClick={() => setModalTab('evento')} className={`px-4 py-2 font-bold text-sm border-b-2 transition-colors ${modalTab === 'evento' ? 'border-purple-600 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>Evento</button>
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Item (Matéria ou Evento)</label>
                        <select value={formAula.materia_id} onChange={(e) => setFormAula({ ...formAula, materia_id: e.target.value, professor_id: '' })} className="w-full border p-2 rounded">
                            <option value="">-- Vazio (Sem Aula) --</option>
                            {materias.filter(m => (modalTab === 'evento' ? m.tipo === 'evento' : m.tipo !== 'evento')).map(m => (<option key={m.id} value={m.id}>{m.nome}</option>))}
                        </select>
                    </div>

                    {modalTab === 'materia' && formAula.materia_id && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Professor</label>
                            <select value={formAula.professor_id} onChange={(e) => setFormAula({ ...formAula, professor_id: e.target.value })} className="w-full border p-2 rounded">
                                <option value="">-- Selecione o Professor --</option>
                                {professores.filter(p => p.aulas?.some(a => a.materia_id === formAula.materia_id)).map(p => {
                                     const info = getInfoProfessor(p.id);
                                     const slotKey = `${editingSlot.dia}-${editingSlot.tempo}`;
                                     const impedido = impedimentos[p.id] && impedimentos[p.id][slotKey];
                                     return <option key={p.id} value={p.id}>{p.nome_completo} {impedido ? '(⚠️ Impedido)' : ''}</option>
                                })}
                            </select>
                        </div>
                    )}
                    
                    {conflictWarning && <div className="p-3 bg-red-50 text-red-700 text-xs rounded border border-red-200">{conflictWarning}</div>}

                    <div className="flex justify-between pt-4">
                         {isEditingExisting ? <Button type="button" variant="danger" onClick={handleDeleteAula} className="flex items-center gap-1"><TrashIcon className="w-4 h-4"/> Excluir</Button> : <div></div>}
                         <div className="flex gap-2"><Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button><Button type="submit" variant="primary">Salvar</Button></div>
                    </div>
                 </form>
            </Modal>

            <Modal show={showConfigPdfModal} onClose={() => setShowConfigPdfModal(false)} title="Configurar Impressão (PDF)">
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Observações (Rodapé do PDF)</label>
                        <textarea rows="3" className="w-full border p-2 rounded text-sm" placeholder="Ex: Pedido de material bélico deve ser feito com 24h de antecedência..." value={pdfConfig.observacoes} onChange={(e) => setPdfConfig({...pdfConfig, observacoes: e.target.value})}></textarea>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Assinaturas</label>
                        {pdfConfig.assinaturas.map((sig, idx) => (
                            <div key={idx} className="flex gap-2 mb-2 items-end">
                                <div className="flex-1"><label className="text-xs text-gray-500">Nome</label><input type="text" className="w-full border p-1.5 rounded text-sm" placeholder="Ex: MARCOS KAZUAKI KOYAMA" value={sig.nome} onChange={(e) => handleSignatureChange(idx, 'nome', e.target.value)} /></div>
                                <div className="flex-1"><label className="text-xs text-gray-500">Função</label><input type="text" className="w-full border p-1.5 rounded text-sm" placeholder="Ex: TEN CEL PM CH DPT ENS" value={sig.funcao} onChange={(e) => handleSignatureChange(idx, 'funcao', e.target.value)} /></div>
                                <button onClick={() => handleRemoveSignature(idx)} className="text-red-500 p-2 hover:bg-red-50 rounded" title="Remover Assinatura"><TrashIcon className="w-4 h-4"/></button>
                            </div>
                        ))}
                        <button onClick={handleAddSignature} className="text-blue-600 text-xs font-bold hover:underline flex items-center gap-1 mt-2">+ Adicionar Assinante</button>
                    </div>
                    
                    <div className="flex justify-between pt-4 border-t">
                        <Button onClick={handleSavePdfConfig} variant="success" className="flex items-center gap-1"><SaveIcon className="w-4 h-4"/> Salvar Configuração</Button>
                        <Button onClick={() => setShowConfigPdfModal(false)} variant="secondary">Fechar</Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};